import { cn } from '@/lib/ui/style-helpers'

import { StringNameAvatar } from '@/components/lemmala-design-system/avatar/string-name-avatar'

import { UserBadgeBase, UserBaseBadgeProps } from './user-badge-base'

type UserBadgeProps = UserBaseBadgeProps & {
  className?: string
  maxInitialsLength?: number
}

export const UserBadge = ({
  name,
  email,
  className,
  onRemove,
  onRestore,
  disabled,
  maxInitialsLength = 2,
  isOnline,
  tooltipDisabled = false,
  onClick,
}: UserBadgeProps) => {
  return (
    <UserBadgeBase
      name={name}
      email={email}
      onRemove={onRemove}
      onRestore={onRestore}
      disabled={disabled}
      isOnline={isOnline}
      tooltipDisabled={tooltipDisabled}
      onClick={onClick}
    >
      <>
        <StringNameAvatar
          name={name}
          className={cn('size-4 text-xs', className)}
          maxLength={maxInitialsLength}
        />
        <span className='max-w-40 truncate text-sm'>{name}</span>
      </>
    </UserBadgeBase>
  )
}
